/**
 * 安全的 JSON 序列化辅助函数
 *
 * 标准 JSON.stringify 无法序列化 BigInt，会抛出
 * "TypeError: Do not know how to serialize a BigInt"。
 * 此函数在遇到 BigInt 时将其转换为字符串，保证日志等场景不会崩溃。
 */
export function safeStringify(value: unknown): string {
  return JSON.stringify(value, (_key, val) => {
    if (typeof val === 'bigint') {
      return val.toString();
    }
    return val;
  });
}
